import React from 'react';

interface LayoutProps {
    onClick: () => void,
    isNotDisturb: boolean
}
export const Layout: React.FC<LayoutProps> = props => {
    const { onClick, isNotDisturb } = props;

    const logo = isNotDisturb ? '../../../../../images/dnd-logo.png' : '../../../../images/panther-system.svg';
    const background = isNotDisturb ? '../../../../../images/background-dnd-web.png' : '../../../../images/background.png';

    return (
        <div
            className = { 'a-layout' }
            onClick = { onClick }>
            <div
                className = { 'a-layout-logo' }
                style = {{ backgroundImage: `url("${background}")` }}>
                <img
                    alt = 'logo'
                    src = { logo } />
            </div>
        </div>);
};
Layout.defaultProps = {
    isNotDisturb: false
};
